import { EvidenceStatusMap } from '../../../../../../constants/chips/evidence-status.constants';

export const isPeriodValid = (filters) => filters?.periodValid;

export const isEditableStatus = (rowData) => {
    const status = rowData?.statusId;
    const editableStatuses = [
        EvidenceStatusMap.submitted,
        EvidenceStatusMap.default,
        EvidenceStatusMap.notStarted,
        EvidenceStatusMap.rejected,
        EvidenceStatusMap.reopened,
    ];
    return editableStatuses.includes(status);
};

export const shouldShowReadOnlyView = (isReadOnly, filters, rowData) => {
    return isReadOnly || !isPeriodValid(filters) || !isEditableStatus(rowData);
};

export const isNewEvidenceCapture = (filters, rowData) => {
    const status = rowData?.statusId;
    const newCaptureStatuses = [EvidenceStatusMap.notStarted, EvidenceStatusMap.default];
    return isPeriodValid(filters) && newCaptureStatuses.includes(status);
};

export const isReopenedEvidence = (filters, rowData) => {
    return isPeriodValid(filters) && rowData?.statusId === EvidenceStatusMap.reopened;
};

export const isRejectedEvidence = (filters, rowData, canEditRejectedEvidence) => {
    const isRejectedStatus = rowData?.statusId === EvidenceStatusMap.rejected;
    return isPeriodValid(filters) && isRejectedStatus && canEditRejectedEvidence;
};

export const isSubmittedEvidence = (filters, rowData) => {
    const isSubmittedStatus = rowData?.statusId === EvidenceStatusMap.submitted;
    return isPeriodValid(filters) && isSubmittedStatus;
};
